module.exports = __webpack_public_path__ + "media/images/city/091-petronas-twin-tower-729865e6cd99605d255019fa7be0ddd0.svg";